export {
    GetCourseQuery,
    GetCoursesQuery,
    GetCourseCollectionQuery,
    GetAccessOLCoursesQuery,
} from './queries';
export { CreateCourseMutation, UpdateCourseMutation, RemoveCourseMutation } from './mutations';
